var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 -952.36)"},React.createElement("path",{"d":"m13 974.36c-2.2091 0-4 1.7908-4 4 0 2.2092 1.7909 4 4 4h74c2.2091 0 4-1.7908 4-4 0-2.2092-1.7909-4-4-4zm0 24c-2.2091 0-4 1.7908-4 4s1.7909 4 4 4h74c2.2091 0 4-1.7908 4-4s-1.7909-4-4-4zm0 24c-2.2091 0-4 1.7908-4 4s1.7909 4 4 4h74c2.2091 0 4-1.7908 4-4s-1.7909-4-4-4z","color":"#000000","overflow":"visible","style":{"blockProgression":"tb","textIndent":"0","textTransform":"none"}})));
}

Menu.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Menu;

Menu.default = Menu;
